import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import BplsDashboardChartContainer from './containers/BplsDashboardChartContainer';
import * as actions from './action';
import * as c from './constant';

function EbossTransactionContainer({ totalStats, getTotalStats }) {

  const returnNewTransactionData = () => {
    const data = _.get(totalStats, 'item.total_bpls_new_per_status');
    return {
      label: 'New',
      total: _.get(totalStats, 'item.total_bpls_new', 0),
      // photo: ''
      list: [
        {
          label: 'For Checking',
          value: _.get(data, 'FOR CHECKING', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'For Resubmission',
          value: _.get(data, 'FOR RESUBMISSION', 0),
          borderClassName: 'rejected',
        },
        {
          label: 'Pending',
          value: _.get(data, 'PENDING', 0),
          borderClassName: 'waiting',
        },
        // { label: 'Approved', value: _.get(data, 'APPROVED', 0), borderClassName: 'paid' },
        {
          label: 'Waiting For Payment',
          value: _.get(data, 'WAITING FOR PAYMENT', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'For Delivery',
          value: _.get(data, 'FOR DELIVERY', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Received',
          value: _.get(data, 'RECEIVED', 0),
          borderClassName: 'received',
        },
      ],
    };
  };

  const returnRenewTransactionData = () => {
    const data = _.get(totalStats, 'item.total_bpls_renewal_per_status');
    return {
      label: 'Renewal',
      total: _.get(totalStats, 'item.total_bpls_renewal', 0),
      // photo: ''
      list: [
        {
          label: 'For Checking',
          value: _.get(data, 'FOR CHECKING', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'For Resubmission',
          value: _.get(data, 'FOR RESUBMISSION', 0),
          borderClassName: 'rejected',
        },
        {
          label: 'Pending',
          value: _.get(data, 'PENDING', 0),
          borderClassName: 'waiting',
        },
        // { label: 'Approved', value: _.get(data, 'APPROVED', 0), borderClassName: 'paid' },
        {
          label: 'Waiting For Payment',
          value: _.get(data, 'WAITING FOR PAYMENT', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'For Delivery',
          value: _.get(data, 'FOR DELIVERY', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Received',
          value: _.get(data, 'RECEIVED', 0),
          borderClassName: 'received',
        },
      ],
    };
  };

  const returnQuarterlyTransactionData = () => {
    const data = _.get(totalStats, 'item.total_bpls_quarterly_per_status');
    return {
      label: 'Quarterly',
      total: _.get(totalStats, 'item.total_bpls_quarterly', 0),
      // photo: ''
      list: [
        {
          label: 'Pending',
          value: _.get(data, 'PENDING', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Waiting For Payment',
          value: _.get(data, 'WAITING FOR PAYMENT', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Paid',
          value: _.get(data, 'PAID', 0),
          borderClassName: 'paid',
        },
      ],
    };
  };

  const returnDelinquentTransactionData = () => {
    const data = _.get(totalStats, 'item.total_bpls_delinquent_per_status');
    return {
      label: 'Delinquent',
      total: _.get(totalStats, 'item.total_bpls_delinquent', 0),
      // photo: ''
      list: [
        {
          label: 'Pending',
          value: _.get(data, 'PENDING', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Waiting For Payment',
          value: _.get(data, 'WAITING FOR PAYMENT', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Paid',
          value: _.get(data, 'PAID', 0),
          borderClassName: 'paid',
        },
      ],
    };
  };

  useEffect(() => {
    getTotalStats();
  }, []);

  return (
    <div className="container-fluid mb-3 pt-4">
      <div className="row">
        <div className="col-4 pl-0">
          
          <DashboardListCard
            data={returnNewTransactionData()}
            className="mb-3"
          />
          <DashboardListCard data={returnRenewTransactionData()} className="mb-3" />
          <DashboardListCard data={returnQuarterlyTransactionData()} className="mb-3" />
          <DashboardListCard data={returnDelinquentTransactionData()} className="mb-3" />
        </div>
        <div className="col-8 pr-0">
          <BplsDashboardChartContainer />
        </div>
      </div>
    </div>
  );
}

EbossTransactionContainer.propTypes = {
  totalStats: PropTypes.instanceOf(Object).isRequired,
  getTotalStats: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  totalStats: _.get(api, `${c.GET_TOTAL_STATS}`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(EbossTransactionContainer);
